import { SxProps, Theme } from "@mui/material";
import { alpha } from "@mui/material/styles";

const adminDashboardStyles: Record<string, SxProps<Theme>> = {
  root: {
    position: "relative",
    minWidth: 0,
    maxWidth: "100%",
    overflowX: "hidden",
    overflowY: "hidden",
    pt: { xs: 10, md: 12 },
    px: { xs: 2, md: 4 },
    pb: 4,
    "&::before": {
      content: '""',
      position: "absolute",
      top: -100,
      right: -100,
      width: 400,
      height: 400,
      borderRadius: "50%",
      background: (t) =>
        t.palette.mode === "dark"
          ? `radial-gradient(circle, ${alpha("#f8481c", 0.08)} 0%, transparent 70%)`
          : `radial-gradient(circle, ${alpha("#f8481c", 0.06)} 0%, transparent 70%)`,
      pointerEvents: "none",
    },
    "&::after": {
      content: '""',
      position: "absolute",
      bottom: -80,
      left: -80,
      width: 300,
      height: 300,
      borderRadius: "50%",
      background: (t) =>
        t.palette.mode === "dark"
          ? `radial-gradient(circle, ${alpha("#ff6b4a", 0.06)} 0%, transparent 70%)`
          : `radial-gradient(circle, ${alpha("#ff6b4a", 0.05)} 0%, transparent 70%)`,
      pointerEvents: "none",
    },
  },
  section: {
    position: "relative",
    zIndex: 1,
    mb: 6,
  },
  addButton: {
    minHeight: 40,
    px: 2,
    py: 1.25,
    fontSize: "0.9375rem",
    fontWeight: 600,
    borderRadius: "10px",
    bgcolor: "#f8481c",
    color: "#fff",
    textTransform: "none",
    boxShadow: "none",
    width: "fit-content",
    "&:hover": {
      bgcolor: "#e03d18",
      color: "#fff",
      boxShadow: "none",
    },
    "& .MuiButton-startIcon": {
      color: "#fff",
    },
    "& .MuiButton-startIcon svg": {
      fontSize: "1.25rem",
    },
    "&:hover .MuiButton-startIcon": {
      color: "#fff",
    },
  },
};

export default adminDashboardStyles;
